import { render, staticRenderFns } from "./duizhangdetail.vue?vue&type=template&id=70a1c63e&scoped=true&"
import script from "./duizhangdetail.vue?vue&type=script&lang=js&"
export * from "./duizhangdetail.vue?vue&type=script&lang=js&"
import style0 from "./duizhangdetail.vue?vue&type=style&index=0&id=70a1c63e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a1c63e",
  null
  
)

export default component.exports